import React, { memo } from 'react'
import { number, arrayOf, string } from 'prop-types'
import { Container, Grid } from '@material-ui/core'
import { Rating, ThemeProvider } from '@gympass/yoga'
import {
  ClickableArea,
  MainPanel,
  Photo,
  Text,
  Title,
  Activities,
  RatingWrapper,
  RatingText,
} from './PanelWithPhoto.style'

function PanelWithPhoto({ photoUrl, title, rating, activities, slug }) {
  const formattedActivities = activities.join(', ')
  const formattedRating = rating.toFixed(1)
  return (
    <Container>
      <ClickableArea
        href={`https://gympass.com/negocios/${slug}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <MainPanel>
          <Grid container>
            <Grid item>
              <Photo src={photoUrl} />
            </Grid>
            <Grid item>
              <Text>
                <Title>{title}</Title>
                <RatingWrapper>
                  <Grid item>
                    <ThemeProvider>
                      <Rating
                        style={{ paddingTop: '4px' }}
                        shape={{ type: 'Star', size: 13 }}
                        value={rating}
                      />
                    </ThemeProvider>
                  </Grid>
                  <Grid item>
                    <RatingText>{formattedRating}</RatingText>
                  </Grid>
                </RatingWrapper>
                <Activities>{formattedActivities}</Activities>
              </Text>
            </Grid>
          </Grid>
        </MainPanel>
      </ClickableArea>
    </Container>
  )
}

PanelWithPhoto.propTypes = {
  photoUrl: string.isRequired,
  title: string.isRequired,
  rating: number.isRequired,
  activities: arrayOf(string).isRequired,
  slug: string.isRequired,
}

export default memo(PanelWithPhoto)
